import app from 'app';
import * as Context from '@component/common/src/util/Context';
import './src/scss/mcom/main.scss';
import './src/scss/mcom/vueHeaderStyleOverride.scss';
import './src/scss/mcom/quickViewColumnWidthOverride.scss';

console.log('this is your app: ', app);
app.brand = 'mcom';
localStorage.setItem('pageType', 'myAccount');
// Load page and features channel listeners
require('./src/radio/mcom')(app);

// --- FEATURES ---//

Context.add('product-pool-media', 'scss', require.context('@component/product-pool-media/src/scss/mcom', true, /\.scss$/));

export default app;
